import { render, staticRenderFns } from "./text-value.vue?vue&type=template&id=157752ba&scoped=true"
import script from "./text-value.vue?vue&type=script&lang=js"
export * from "./text-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157752ba",
  null
  
)

export default component.exports